import { Flex } from '@/components/ui/flex'

const Body = ({ children }: { children?: React.ReactNode }) => {
    return (
        <Flex height="100%" flexGrow="1">
            {children}
        </Flex>
    )
}

export default Body
